import { render, staticRenderFns } from "./TenantSubNav.vue?vue&type=template&id=0c4ded52&scoped=true&"
import script from "./TenantSubNav.vue?vue&type=script&lang=js&"
export * from "./TenantSubNav.vue?vue&type=script&lang=js&"
import style0 from "./TenantSubNav.vue?vue&type=style&index=0&id=0c4ded52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4ded52",
  null
  
)

export default component.exports